<section id="paymentMethodsList" class="payment-methods-list">
    <mat-accordion>
        <mat-expansion-panel [expanded]="expandedPanel" hideToggle disabled="true" class="mat-elevation-z0">
            <mat-expansion-panel-header class="p-0">
                @if (!methodsForThreshold.length && !paymentMethodsList.length && !isSelectingPaymentMethod) {
                    <div class="d-flex error-message mb-2">
                        There was a technical issue on our end loading your payment methods. Please try again by logging
                        out, then logging back in. If the issue persists please contact support&#64;cargosprint.com
                    </div>
                } @else {
                    <div class="d-flex flex-column flex-grow-1">
                        <ng-content />
                        <div class="d-flex justify-content-between mb-3">
                            <div class="mat-subtitle-1 methods-title">Payment method</div>
                            @if (!expandedPanel) {
                                <button
                                    id="change-or-select-payment-method"
                                    mat-button
                                    type="submit"
                                    color="primary"
                                    class="link mat-subtitle-2"
                                    (click)="togglePanel()"
                                >
                                    {{
                                        paymentMethodSelected?.method
                                            ? 'Change'
                                            : `Select payment
                            method`
                                    }}
                                </button>
                            } @else {
                                <button
                                    id="close-select-payment-method"
                                    mat-button
                                    type="button"
                                    color="primary"
                                    class="d-flex link mat-subtitle-2"
                                    (click)="togglePanel()"
                                >
                                    <mat-icon matIconPrefix class="close-icon">close</mat-icon>
                                    Close
                                </button>
                            }
                        </div>
                        <div class="d-flex flex-xs-column flex-row flex-grow-1 align-items-center mb-32">
                            @if (!isSelectingPaymentMethod) {
                                <div class="d-flex flex-grow-1 w-100">
                                    <app-authenticated-payment-method [aboveThreshold]="aboveThreshold" />
                                </div>
                            } @else {
                                <!--START: LOADER -->
                                <div class="d-flex justify-content-center flex-grow-1">
                                    <mat-spinner [diameter]="30" />
                                </div>
                                <!--END: LOADER -->
                            }
                        </div>
                    </div>
                }
            </mat-expansion-panel-header>
            <div class="d-flex justify-content-between mb-4">
                <div class="d-flex mat-subtitle-1 methods-title mb-0">Select a payment method</div>
            </div>
            @if ((aboveThreshold && !methodsForThreshold.length) || !aboveThreshold) {
                @for (method of paymentMethodsList; track $index) {
                    @if (method.name === PaymentMethods.CREDIT_CARD) {
                        <div class="methods-container">
                            <app-credit-cards-list
                                [aboveThreshold]="aboveThreshold"
                                (eventOnSelectCreditCard)="selectPaymentMethod(PaymentMethods.CREDIT_CARD, $event)"
                            />
                            <div class="d-flex">
                                <button
                                    mat-button
                                    type="submit"
                                    class="mat-subtitle-1 mb-0 btn-add-new"
                                    color="primary"
                                    (click)="redirectToCreditCard()"
                                >
                                    <mat-icon matIconPrefix>add</mat-icon>
                                    ADD NEW CREDIT CARD
                                </button>
                            </div>
                        </div>
                    }
                    @if (method.name === PaymentMethods.ECHECK) {
                        <div class="methods-container">
                            <mat-divider class="mx-0 my-4" [inset]="true" />
                            <app-echecks-list
                                [aboveThreshold]="aboveThreshold"
                                (eventOnSelectEcheck)="selectPaymentMethod(PaymentMethods.ECHECK, $event)"
                            />
                            <div class="d-flex">
                                <button
                                    mat-button
                                    type="submit"
                                    class="mat-subtitle-1 mb-0 btn-add-new"
                                    color="primary"
                                    (click)="redirectToEcheck()"
                                >
                                    <mat-icon matIconPrefix>add</mat-icon>
                                    ADD NEW BANK ACCOUNT (ACH)
                                </button>
                            </div>
                        </div>
                    }
                    @if (method.name === PaymentMethods.CARGO_CREDIT && !aboveThreshold) {
                        <div class="methods-container">
                            <mat-divider class="mx-0 my-4" [inset]="true" />
                            <app-cargo-credit
                                [aboveThreshold]="aboveThreshold"
                                (eventOnSelectCargoCredit)="selectPaymentMethod(PaymentMethods.CARGO_CREDIT)"
                            />
                        </div>
                    }
                    @if (method.name === PaymentMethods.FINANCE) {
                        <div class="methods-container">
                            <mat-divider class="mx-0 my-4" [inset]="true" />
                            <app-finance-credit
                                [aboveThreshold]="aboveThreshold"
                                (eventOnSelectFinance)="selectPaymentMethod(PaymentMethods.FINANCE)"
                            />
                        </div>
                    }
                    @if (method.name === PaymentMethods.SPRINTPAY_FLEX) {
                        <div class="methods-container">
                            <mat-divider class="mx-0 my-4" [inset]="true" />
                            <app-sprintpay-flex
                                [aboveThreshold]="aboveThreshold"
                                (eventOnSelectSprintpayFlex)="selectPaymentMethod(PaymentMethods.SPRINTPAY_FLEX)"
                            />
                        </div>
                    }
                    @if (method.name === PaymentMethods.PAYPAL && !aboveThreshold && !isCartAboveThreshold) {
                        <div class="methods-container" *appHideDownload>
                            <mat-divider class="mx-0 my-4" [inset]="true" />
                            <app-paypal
                                [aboveThreshold]="aboveThreshold"
                                (eventOnSelectPaypal)="selectPaymentMethod(PaymentMethods.PAYPAL)"
                            />
                        </div>
                    }
                }
                <mat-divider class="mx-0 mt-4" [inset]="true" />
            }
            @if (aboveThreshold && methodsForThreshold.length) {
                <div class="d-flex flex-column">
                    @for (method of methodsForThreshold; track $index) {
                        @if (method.name === PaymentMethods.CREDIT_CARD) {
                            <div class="methods-container">
                                <app-credit-cards-list
                                    [aboveThreshold]="aboveThreshold"
                                    (eventOnSelectCreditCard)="selectPaymentMethod(PaymentMethods.CREDIT_CARD, $event)"
                                />
                                <div class="d-flex">
                                    <button
                                        mat-button
                                        type="submit"
                                        class="mat-subtitle-1 mb-0 btn-add-new"
                                        color="primary"
                                        (click)="redirectToCreditCard()"
                                    >
                                        <mat-icon matIconPrefix>add</mat-icon>
                                        ADD NEW CREDIT CARD
                                    </button>
                                </div>
                                <mat-divider class="m-4" [inset]="true" />
                            </div>
                        }
                        @if (method.name === PaymentMethods.ECHECK) {
                            <div class="methods-container">
                                <app-echecks-list
                                    [aboveThreshold]="aboveThreshold"
                                    (eventOnSelectEcheck)="selectPaymentMethod(PaymentMethods.ECHECK, $event)"
                                />
                                <div class="d-flex mb-4">
                                    <button
                                        mat-button
                                        type="submit"
                                        class="mat-subtitle-1 mb-0 btn-add-new"
                                        color="primary"
                                        (click)="redirectToEcheck()"
                                    >
                                        <mat-icon matIconPrefix>add</mat-icon>
                                        ADD NEW BANK ACCOUNT (ACH)
                                    </button>
                                </div>
                                <mat-divider class="m-4" [inset]="true" />
                            </div>
                        }
                        @if (method.name === PaymentMethods.FINANCE) {
                            <div class="methods-container mb-4">
                                <app-finance-credit
                                    [aboveThreshold]="aboveThreshold"
                                    (eventOnSelectFinance)="selectPaymentMethod(PaymentMethods.FINANCE)"
                                />
                                <mat-divider class="m-4" [inset]="true" />
                            </div>
                        }
                        @if (method.name === PaymentMethods.SPRINTPAY_FLEX) {
                            <div class="methods-container">
                                <app-sprintpay-flex
                                    [aboveThreshold]="aboveThreshold"
                                    (eventOnSelectSprintpayFlex)="selectPaymentMethod(PaymentMethods.SPRINTPAY_FLEX)"
                                />
                                <mat-divider class="m-4 mb-0" [inset]="true" />
                            </div>
                        }
                    }
                </div>
            }
        </mat-expansion-panel>
    </mat-accordion>
</section>
